import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ArrowRight = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path fill="currentColor" d="M12.2 9H0V7h12.2L6.8 1.6 8.2.2 16 8l-7.8 7.8-1.4-1.4L12.2 9Z" />
  </svg>
));
